module.exports = __webpack_public_path__ + "static/img/victim-teens-5.a24a6684.png";